import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import data_activities from '../../assets/json/activities.json';
import { Activity } from '../models/activity.model';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  private activities: Activity[] = [];

  constructor(private i18n: TranslateService) {
    this.activities = data_activities;
  }

  exportMenuItems() {
    const items: any[] = [];
    this.activities.forEach((activity) => {
      let item = {
        id: activity.codeTrad,
        url: `/activity/${activity.id}`
      }
      items.push(item);
    });

    return items;
  }
  
  getAll(): Activity[] {
    return this.activities;
  }

  getById(id: number): Activity | undefined {
    return this.activities.find((activity) => activity.id === id);
  }

  exportCarousel(): any[] {
    const items: any[] = []
    this.activities.forEach((activity) => {
      const item = {title: activity.codeTrad, url: `/activity/${activity.id}`, coverPath: activity.images.find(image => image.cover)?.path};
      if(activity.caroussel) {
        items.push(item);
      }
    });

    return items;
  }
}
